import * as THREE from 'three';

/** The fight's own key, fill and ambient, and the switch that turns them off. */
export interface SimLighting {
  /**
   * On inside an engagement, off in cruise.
   *
   * Off is an intensity of zero and not a detach: the lights stay in the scene
   * so the program cache key does not change when a fight opens, which would
   * relink every material in the frame on the one tick the player least wants
   * it. In cruise the ship is lit by the Atlas's own sun, which is where the
   * sun actually is.
   */
  setFightLook(on: boolean): void;
  dispose(): void;
}

export function addLighting(scene: THREE.Object3D): SimLighting {
  const sun = new THREE.DirectionalLight(0xfff2d8, 2.5);
  sun.position.set(-220, 90, 300);
  scene.add(sun);

  const ambient = new THREE.AmbientLight(0x3a4878, 0.38);
  scene.add(ambient);

  // Warm fill from the Mars side — bounce off a dusty planet, so LOW chroma.
  // The old 0xff6a33 added 0.5 to a rock's mean luminance but 155/255 of
  // red-over-blue to the crests it caught, which read as molten, not bounced.
  const fill = new THREE.DirectionalLight(0xcf9a74, 0.50);
  fill.position.set(280, -10, -160);
  scene.add(fill);

  const lit: Array<[THREE.Light, number]> = [[sun, 2.5], [ambient, 0.38], [fill, 0.50]];
  return {
    setFightLook(on: boolean): void {
      for (const [light, intensity] of lit) light.intensity = on ? intensity : 0;
    },
    dispose(): void {
      for (const [light] of lit) { light.removeFromParent(); light.dispose(); }
    },
  };
}
